export default function ({ language }) {
  var config = {
    validators: ['mandatory', 'onlyDigits'],
    thousands: '',
    suffix: 'mm',
    format: 'integer',
    placeholder: '1000 mm',
  };

  return {
    config,
    extendsType: 'text-field',
  };
}
